export const backendBaseURL = process.env.REACT_APP_BACKEND_URL;
export const backendAPIBaseURL = process.env.REACT_APP_BACKEND_API_URL;
export const frontEndBaseURL = process.env.REACT_APP_FRONTEND_URL;
export const cloudinaryImageUploadAPI =
  process.env.REACT_APP_CLOUDINARY_IMAGE_UPLOAD_API;

// Auth API
export const loginAPI = `/auth/login`;
export const resetPasswordSendOTPAPI = `/auth/reset-password-sent-otp`;
export const resetPasswordVerifyOTPAndResetPasswordAPI = `/auth/reset-password-verify-otp-and-reset-password`;

//Users API
export const createUserAPI = `/users/create`;
export const createStaffMemberAPI = `/users/create-staff-user/[1]`;
export const getAllRestaurantOwnerUsersAPI = `/users/get-all-restaurant-owner-user`;
export const getUserbyIdAPI = `/users/get-user/[1]`;
export const getUsersByRestaurantIdAPI = `/users/get-users-by-restaurant-id/[1]`;
export const changeUserStatusAPI = `/users/change-user-status/[1]`;
export const updateUserAPI = `/users/update/[1]`;
export const deleteUserAPI = `/users/delete/[1]`;

// Restaurant API
export const createRestaurantAPI = `/restaurants/create`;
export const getAllRestaurantAPI = `/restaurants/get-all`;
export const getRestaurantByIdAPI = `/restaurants/get/[1]`;
export const updateRestaurantAPI = `/restaurants/update/[1]`;
export const addRestauranTableAPI = `/restaurants/[1]/add-table`;
export const updateRestauranTableAPI = `/restaurants/[1]/update-table/[2]`;
export const deleteRestaurantTableAPI = `/restaurants/[1]/delete-table/[2]`;
export const addParcelOrderAPI = `/restaurants/[1]/create-parcel-order`;
export const applyDiscountAPI = `/restaurants/[1]/apply-discount`;
export const updateOrderAPI = `/restaurants/[1]/update-order`;
export const cancelOrderAPI = `/restaurants/[1]/cancel-order`;
export const markOrderPaidAPI = `/restaurants/[1]/mark-paid`;
export const completeParcelOrderAPI = `/restaurants/[1]/complete-parcel-order`;
export const placeTableOrderAPI = `/restaurants/[1]/place-table-order/[2]`;
export const getTableOrderAPI = `/restaurants/[1]/fetch-table-order/[2]/`;
export const getParcelOrderAPI = `/restaurants/[1]/fetch-parcel-order/[2]`;
export const updateDishStatusAPI = `/restaurants/[1]/update-dish-status`;
export const getAllTablesAPI = `/restaurants/[1]/fetch-tables`;
export const getParcelsOrderAPI = `/restaurants/[1]/fetch-parcels-order`;

// Orders
export const saveOrderAPI = `/orders/[1]/create`;
export const getOrdersAPI = `/orders/[1]/fetch-orders-history`;

// Menu API
export const menuByRestaurantIdAPI = `/menu/get-restaurant-id/[1]`;
export const createMenuAPI = `/menu/create`;
export const getAllMenuAPI = `/menu/get-all`;
export const getMenuByIdAPI = `/menu/get/[1]`;
export const getNewCategoriesAPI = `/menu/[1]/get-categories`;
export const addNewCategoryAPI = `/menu/[1]/add-category`;
export const editCategoryAPI = `/menu/[1]/edit-category/[2]`;
export const deleteCategoryAPI = `/menu/[1]/delete-category/[2]`;
export const addNewDishItemAPI = `/menu/[1]/add-new-dish-item`;
export const changeAvailabilityDishItemAPI = `/menu/[1]/change-dish-item-availability/[2]`;
export const updateDishItemAPI = `/menu/[1]/update-dish-item/[2]`;
export const deleteDishItemAPI = `/menu/[1]/delete-dish-item/[2]`;
export const getTableOrdersAPI = "/menu/[1]/table-orders/[2]";
